const FEATURES = [
  { icon: "ri-smartphone-line", title: "多平台同步", text: "在主流漫画阅读平台均可搜索到正版更新，支持横屏阅读与章节缓存。" },
  { icon: "ri-bookmark-line", title: "追更提醒", text: "收藏作品后，更新新章节会第一时间收到提醒，不错过每一话。" },
  { icon: "ri-community-line", title: "读者社区", text: "每话下方都有读者讨论区，可以一起磕CP、聊设定、做剧情猜想。" },
];

const QUOTES = [
  { text: "本来只是随手点开，结果一口气追了几十话，辅助器小爱真的又毒舌又可爱。", from: "读者 · 小岛上的风" },
  { text: "喜欢它不靠狗血推动剧情，很多话都在认真讲「真诚待人」这件事。", from: "读者 · 熬夜的桃" },
  { text: "主角从社恐到敢表白的成长线太戳我了，看完心里暖暖的。", from: "读者 · 云川市市民" },
];

export default function Track() {
  return (
    <section id="track" className="relative overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/60 via-background-50 to-accent-100/60"></div>
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
              <i className="ri-fire-line"></i>
              口碑与追更
            </span>
            <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
              一部让你<span className="text-primary-600">笑着心动</span>的漫画
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-700">
              设定有趣、节奏明快，更难得的是在轻松搞笑之外藏着真实的成长与温度。
              无论你是恋爱题材爱好者，还是想找一部治愈系放松作品，它都值得一试。
            </p>

            <div className="mt-8 space-y-4">
              {FEATURES.map((f) => (
                <div key={f.title} className="flex items-start gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="text-base font-bold text-foreground-900">{f.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{f.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://backgrounds0.github.io"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              前往正版平台追更
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-2 text-accent-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-half-line"></i>
                <span className="ml-2 text-sm text-foreground-600">读者综合口碑</span>
              </div>
              <p className="mt-3 font-heading text-4xl text-foreground-900">
                4.8<span className="text-lg text-foreground-500"> / 5</span>
              </p>
              <p className="mt-1 text-sm text-foreground-600">基于读者评分与追更讨论的综合评价</p>
            </div>

            {QUOTES.map((q) => (
              <blockquote
                key={q.from}
                className="rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <p className="text-sm leading-relaxed text-foreground-700">「{q.text}」</p>
                <footer className="mt-3 text-xs text-foreground-500">—— {q.from}</footer>
              </blockquote>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}